import { useEffect, useState } from "react";

/**
 * Delays the update of a value until after the specified delay.
 * Trims whitespace if the value is a string.
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (default: 500ms)
 */
export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      // If value is a string, trim it before setting
      if (typeof value === 'string') {
        setDebouncedValue(value.trim() as T);
      } else {
        setDebouncedValue(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
